import API from 'shared/api/API';
import { GET, POST } from 'shared/utils/Executer';
import { USER_SERVICE_URL } from 'shared/constants/APIconstants';

class UserAPI {
  /**
   * Merge two users by their email addresses
   * @param {Object} params
   * @param {string} params.primaryEmail - Primary user email (data will be merged into this user)
   * @param {string} params.secondaryEmail - Secondary user email (this user will be deleted after merge)
   * @returns {Promise<{user: Object, migrationStats: Object}>} Merged user and migration statistics
   */
  async mergeUsers({ primaryEmail, secondaryEmail }) {
    return await API.client.execute(POST, `${USER_SERVICE_URL}merge-users`, {
      primaryEmail,
      secondaryEmail,
    });
  }

  /**
   * Get user data with their subscriptions by email
   * @param {string} email - User email address
   * @returns {Promise<{user: Object, subscriptions: Array, primaryOrganization: Object}>}
   */
  async getUserWithSubscriptions(email) {
    return await API.client.execute(
      GET,
      `${USER_SERVICE_URL}subscriptions?email=${encodeURIComponent(email)}`,
    );
  }
}

export default new UserAPI();
